exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.title-dark[data-v-a63898ae] {\n  color: #fff;\n  font-weight: 300;\n}\n.title-light[data-v-a63898ae] {\n  color: #455a64;\n  font-weight: 300;\n}\n.subtitle-light[data-v-a63898ae] {\n  color: #99abb4;\n}\n.noHover[data-v-a63898ae] {\n  color: #455a64;\n  font-weight: 300;\n}\n.bg-dark[data-v-a63898ae]:hover{\n  background-color: #455a64!important\n}\n.white[data-v-a63898ae]:hover{\n  background-color:  lightgray!important\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a63898ae","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/Infobox.vue
// module id = S/Dz
// module chunks = 1